import React, { useEffect, useState } from 'react';
import * as API from '../../../framework/API/api';
import BossDialog from '../../../components/BossDialog';
import { EditPageHeader } from '../../../components/EditPageHeader';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { ENTITYNAME, TOAST_TYPES } from '../../../framework/constant/constant';
import { useTranslation } from '../../../locale/useTranslation';
import ToastNotification from '../../../components/ToastNotification';

const PlanningMetaDataEditForm = (props) => {
    const { planningId, onClose } = props;

    const lang = useTranslation();

    const [dataItem, setDataItem] = useState({
        Description: '',
        CustomDescription: '',
        SubGenres: {}
    });

    const [subGenres, setSubGenres] = useState([]);
    const [planningData, setPlanningData] = useState(null);
    const [isUpdateAllSlots, setIsUpdateAllSlots] = useState(false)

    useEffect(() => {
        loadCombo();
    }, []);

    useEffect(() => {
        if (planningId) {
            loadData(planningId);
        }
    }, [planningId]);

    const loadCombo = async () => {
        let subGenreRes = await API.getDataLookup(ENTITYNAME.Genre);
        setSubGenres(subGenreRes.data);
    };

    const loadData = async (planningId) => {
        let res = await API.getData(ENTITYNAME.ProgramSchedule, { query: ['_id', '=', planningId] });
        if (res.success && res.data && res.data.length > 0) {
            let planningRes = res.data[0];
            setPlanningData(planningRes);
            let epgMetaData = planningRes?.EpgMetaData || {};
            setDataItem({
                Description: epgMetaData?.Description ?? '',
                CustomDescription: epgMetaData?.CustomDescription ?? '',
                SubGenres: epgMetaData?.SubGenres?.length > 0 ? epgMetaData?.SubGenres?.[0] : {},
            });
        } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message || lang.failed_to_load_slot_metadata_error_message });
        }
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

const onSave = async () => {
    if (!planningData) return;

    const epgMetaData = {
        Description: dataItem.Description,
        CustomDescription: dataItem.CustomDescription,
        SubGenres: Object.keys(dataItem.SubGenres || {}).length > 0 ? [{_id : dataItem?.SubGenres?._id, Description: dataItem?.SubGenres?.Description}]: []
    };

    let res;

    if (isUpdateAllSlots && planningData.MediaEpisode_id) {

        res = await API.bulkUpdate(ENTITYNAME.ProgramSchedule,
            {
                EpgMetaData: epgMetaData
            },
            ['MediaEpisode_id', '=', planningData.MediaEpisode_id]
        );

    } else {

        const finalData = {_id: planningData?._id , EpgMetaData: epgMetaData};
        res = await API.saveData(ENTITYNAME.ProgramSchedule,finalData);

    }
    if (res.success) {
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.slot_metadata_updated_successfully });
        onClose();
    } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        onClose()
    }
};

    return (
        <BossDialog title={lang.edit_slot_metadata_label} width={"700px"} onClose={onClose}>
            <div className="d-flex align-items-center mb-2">
                <div>
                    <EditPageHeader showTitle={false} onSubmit={onSave} onCancel={onClose} />
                </div>
                <div className="d-flex align-items-center mt-3 mb-2 ml-3">
                    <input
                        type="checkbox"
                        value={isUpdateAllSlots}
                        checked={isUpdateAllSlots}
                        onChange={() => setIsUpdateAllSlots(!isUpdateAllSlots)}
                    />
                    <label className="ms-1 mb-0 ml-1 mt-1" style={{ fontWeight: 'bold' }}>
                        Update All Slots
                    </label>
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-4 mb-2">
                    <label htmlFor="SubGenres">{lang.subgenre_label}</label>
                    <DropDownList
                        name="SubGenres"
                        textField="Description"
                        dataItemKey="_id"
                        data={subGenres}
                        value={dataItem.SubGenres}
                        onChange={onChange}
                        className="form-control-sm w-100 p-0"
                    />
                </div>
                <div className="col-12 mb-2">
                    <label htmlFor="Description">{lang.description_label}</label>
                    <textarea
                        name="Description"
                        placeholder="Enter Description"
                        className="form-control form-control-sm"
                        rows="3"
                        value={dataItem.Description}
                        onChange={onChange}
                    />
                </div>
                <div className="col-12 mb-2">
                    <label htmlFor="CustomDescription">{lang.custom_description_label}</label>
                    <textarea
                        name="CustomDescription"
                        placeholder="Enter Custom Description"
                        className="form-control form-control-sm"
                        rows="3"
                        value={dataItem.CustomDescription}
                        onChange={onChange}
                    />
                </div>
            </div>
        </BossDialog>
    );
};

export default PlanningMetaDataEditForm;